import React, { useState, useContext, useEffect } from 'react';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';

import '../../styles/mainlayout.css';
import ThemeToggle from '../themetoggle';
import Logo from '../../assets/logo.png'; 
import { ShareContext } from '../../context/ShareContext'
import DynamicIcon from '../dynamicicon';
import JisAlert from '../jisalert';
import JisPrompt from '../jisprompt';

function MainLayout() {
    const navigate = useNavigate();
    const [active, setActive]=useState(-1);
    const { profile , setToken, sidelinks, activePage, token, checkingToken, setActivePage,isExpired,setIsExpired, alert,setAlert} = useContext(ShareContext);
    const [search, setSearch] = useState('');
    const [openMenus, setOpenMenus] = useState({});
    const [isDraft, setIsDraft] = useState(false);

  const handleToggle = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const onLogout=()=>{
          localStorage.removeItem("token");
          localStorage.removeItem("profile");
          setToken(null);
          setIsExpired(false)
          navigate('/login');
  }
  

  useEffect(() => {
     var cc=localStorage.getItem("caseinfo");

     if(cc!=null){
      //dislay alert over the display screen
      var _sf=JSON.parse(cc);
      if(_sf.userid==profile?.id){
         setIsDraft(true);
      }
       
     }
          
      }, [])

      const onDraftOk=()=>{
        setIsDraft(false);
        navigate('/case-filing')
      }
      const onDraftCancel =()=>{
        setIsDraft(false);
          localStorage.removeItem('caseinfo');
      }

      const onCloseAlert=()=>{
        setAlert({open:false});
      }

      const onChangeProfile=()=>{
        navigate('/profile')
      }

if (checkingToken) return <div style={{background:'var(--primary)', padding:16, color:'var(--background)'}}><div className="spinner"></div> JIS System reconnecting</div>;
  return  token ?  (
    <div className="layout-wrapper">
      
      {/* Side Bar */}
     <div className='sidebar'>
          <div>
            <img src={Logo} alt="JIS Logo"  />
        </div>
        {/*{id,title,url,isParent,icon,note,helpLink, parentId} */}
<div className='no-print' style={{display:'flex', flexDirection:'column', flex:1}}>
  
    
    <nav className="sidebar-links">
  <ul>
    {sidelinks.map((item) => (
      <li key={item.id} className={`${item.code==activePage.code?'active':''}`}>
        {/* Parent with children: just toggle */}
        {item.inner && item.inner.length > 0 ? (
          <div
            onClick={() => handleToggle(item.id)}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <DynamicIcon iname={item.icon} />
            <span>{item.title}</span>
            <span style={{ marginLeft: 'auto' }}>
              {openMenus[item.id] ? (
                <DynamicIcon iname="chevron-up" />
              ) : (
                <DynamicIcon iname="chevron-down" />
              )}
            </span>
          </div>
        ) : (
          // Standalone link
          <Link onClick={()=>setActivePage(item)}
            to={item.url}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <DynamicIcon iname={item.icon} />
            <span>{item.title} </span>
          </Link>
        )}

        {/* Children */}
        {item.inner && item.inner.length > 0 && openMenus[item.id] && (
          <ul className={`submenu ${openMenus[item.id] ? 'open' : ''}`} style={{ paddingLeft: '20px' }}>
            {item.inner.map((subItem) => (
              <li key={subItem.id} className={`${subItem.code==activePage.code?'active':''}`}>
                <Link onClick={()=>setActivePage(item)}
                  to={subItem.url}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <DynamicIcon iname={subItem.icon} color="var(--primary)" />
                  <span style={{color:'var(--bold_text)'}}>{subItem.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ul>
</nav>

   <div>
    <div className='special-menu-link'
  onClick={onLogout}
  style={{
    color: 'var(--primary)', 
  }}
>
 <DynamicIcon iname='headset' size={20}/> <span style={{  margin:1}}>Help</span> 
</div>
    <div className='special-menu-link'
  onClick={onLogout}
  style={{
    color: 'red', 
  }}
>
 <DynamicIcon iname='log-out' size={20}/> <span style={{  margin:1}}>Logout</span> 
</div>
   </div>
   

</div>
     </div>

      
      
       
      

      {/* Main Content */}
      <div className="main-content" >
        
        {/* Top Bar */}
       
        <div className="top-bar no-print">
 {/*  <h1 className="top-bar-title">{activePage.title} </h1> */}
  <div>
 
  <div style={{fontSize:24, fontWeight:600, fontFamily:'sans-serif'}}>
 {profile.suffix} {profile.firstName} {profile.lastName}
  </div>
<div>{profile.role.name}</div>
  </div>
  <div className="top-bar-right">
   
<DynamicIcon iname='bell-ring' />
    <div className="people-icon-box"  onClick={onChangeProfile}>
      <DynamicIcon iname="user-round-check" size={18} />
    </div>
{/* 
   

    <ThemeToggle /> */}
  </div>
</div>



        {/* Body */}
        <div className="page-body" style={{ marginTop: '24px' }}>
          <Outlet />
        </div>
      </div>
      
      <JisPrompt open={isDraft} title="Unfinished Case filing" onOk={onDraftOk} onCancel={onDraftCancel}>
          <p>We observe you have an ongoing case filing, do you want to continue? Click Yes to continue, Click No to cancel.</p>
      </JisPrompt>
 {isExpired && <JisAlert open={isExpired} title='Session Expired' subtitle="The current login session as expired. Login again to continue" 
actiontext="Goto Login" icon='close' onOk={onLogout} />}
 {alert.open && <JisAlert open={alert.open}  icon={alert.icon} title={alert.title} subtitle={alert.subtitle}
actiontext="Ok" onOk={onCloseAlert} />}
    </div>
  ): <Navigate to="/login" replace />;
}

export default MainLayout;
